import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { API, fileUpload, get } from "../../config";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { NumericFormat } from "react-number-format";
import { MaxLimit } from "../../lib/Misc";
import { cn } from "../../lib/utils";
import SearchSelect from "../../components/SearchSelect";
// import { AddProcessingFeeSchema } from "../../lib/Validation";

const AddEditProcessingFee = ({
  id,
  toggleShowAddEditProcessingFee,
  edit,
  fetchProcessingFeeData,
  trustId,
}) => {
  const [processingFeeData, setProcessingFeeData] = useState([]);
  const [loading, setLoading] = useState(false);

  const processingFeeTypeList = [
    { label: "%", value: "1" },
    { label: "Flat Amount", value: "0" },
  ];

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.GET_PROCESSING_FEE_CODES}/` + id);

      setProcessingFeeData(reponse?.data?.data);
      setLoading(false);
    } catch (e) {
      setProcessingFeeData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleFormSubmit = async (value, { setErrors, resetForm }) => {
    const formData = new FormData();
    value.processing_fee = Number(`${value?.processing_fee}`.replace(/,/g, ""));

    formData.append("trust_id", trustId);
    formData.append("code", value?.code ? value?.code : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );
    formData.append("processing_fee_type", value?.processing_fee_type);
    formData.append(
      "processing_fee",
      value?.processing_fee ? value?.processing_fee : ""
    );

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.PROCESSING_FEE_CODE_ADD}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditProcessingFee();
        fetchProcessingFeeData && fetchProcessingFeeData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        code: processingFeeData?.code,
        description: processingFeeData?.description,
        processing_fee_type: processingFeeData?.processing_fee_type
          ? processingFeeData?.processing_fee_type
          : processingFeeTypeList[0],
        processing_fee: processingFeeData?.processing_fee,
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      // validationSchema={AddProcessingFeeSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true}/>}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden p-4 border rounded-lg">
              <div className="grid gap-4">
                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="code">
                    <CustomLabelText
                      required={true}
                      labelText="Code"
                      errorField={errors?.code}
                    />
                  </Label>
                  <Input
                    id="code"
                    placeholder="Enter Name"
                    required
                    name="code"
                    onChange={(e) => {
                      setFieldValue("code", e?.target?.value);
                    }}
                    onBlur={handleBlur}
                    value={values?.code}
                    className={
                      errors?.code &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>

                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="processing_fee_type">
                    <CustomLabelText
                      required={true}
                      labelText="Processing Fee Type"
                      errorField={errors?.processing_fee_type}
                    />
                  </Label>

                  <SearchSelect
                    frameworks={processingFeeTypeList}
                    optionType={"Processing Fee Type"}
                    handleSelect={(e) => {
                      setFieldValue("processing_fee_type", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.processing_fee_type &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.processing_fee_type}
                  />
                </div>

                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="processing_fee">
                    <CustomLabelText
                      required={true}
                      labelText="Processing Fee"
                      errorField={errors?.processing_fee}
                    />
                  </Label>
                  <NumericFormat
                    type="text"
                    name="processing_fee"
                    value={values?.processing_fee}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    decimalScale={2}
                    allowNegative={false}
                    thousandSeparator={true}
                    isAllowed={(values) => MaxLimit(values)}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.processing_fee
                        ? `${cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )} focus-visible:ring-red-500 border-red-500`
                        : cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )
                    }
                  />
                </div>

                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="description">
                    <CustomLabelText
                      required={false}
                      labelText="Description"
                      errorField={errors?.description}
                    />
                  </Label>
                  <Textarea
                    id="description"
                    name="description"
                    value={values?.description ? values?.description : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.description &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditProcessingFee();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditProcessingFee;
